// extracted by mini-css-extract-plugin
var _1 = "Breadcrumbs-moduleBreadcrumbs__j2C8Y";
var _2 = "Breadcrumbs-moduleskeleton__XyOaI Skeleton-moduleSkeleton__Mlrfv";
export { _1 as "Breadcrumbs", _2 as "skeleton" }
